import React, { useContext } from 'react';
import { Text, ArrowLink } from 'react-onei';

import TagService from '../../../services/TagService';
import { events } from '../../../conf/tags_ga.conf';
import UserContext from '../../../context/UserContext';

function ConfidentialMessage() {
    const { wording, webViewMode } = useContext(UserContext);
    const { WLOST_604, WLOST_610 } = wording;

    return (
        <>
            <Text id="password-best-practices" className="spacing-m">
                {WLOST_604}
            </Text>
            { !webViewMode && (
                <ArrowLink
                    id="link-phishing-info"
                    href={window.reactAppEnv.href.phishingInfo}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => TagService.sendEvent(events.phishingInfo)}
                    aria-label={WLOST_610}
                    title={WLOST_610}
                >
                    {WLOST_610}
                </ArrowLink>
            )}
        </>
    );
}

ConfidentialMessage.defaultProps = {
};

ConfidentialMessage.propTypes = {
};

export default ConfidentialMessage;